export const getCroppedString = (str: string, max_size: number): string => {
  if (str.length <= max_size + 1) {
    return str;
  }
  return `${str.slice(0, max_size)}...`;
};

export const toTitleCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const ignoreCaseCompare = (str1?: string, str2?: string): boolean => {
  return (str1 || "").toLowerCase() === (str2 || "").toLowerCase();
};

export const validExternalUrl = (url: string): string => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `https://${url}`;
};

export const translateText = async (
  text: string,
  language: string
): Promise<string> => {
  const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=pt-br&tl=${language}&dt=t&q=${encodeURI(text)}`;
  const response = await fetch(url);
  const data = await response.json();
  if (Array.isArray(data[0])) {
    return data[0].map((item: any) => item[0]).join("");
  }
  return text;
};
